import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M15.864 11.72a12.2 12.2 0 0 0-4.056-.679c-1.422.003-2.789.25-4.06.698a1.4 1.4 0 0 0-.224.091.88.88 0 0 0-.425.598c-.011.068-.011.136-.012.271 0 .414-.001.621-.038.793a1.69 1.69 0 0 1-1.293 1.293c-.172.037-.38.038-.793.039h-.23c-.63.002-.944.002-1.198-.08a1.66 1.66 0 0 1-1.066-1.066c-.083-.255-.083-.57-.081-1.198v-.187c.002-.627.003-.94.097-1.273.104-.37.377-.833.65-1.104.245-.244.46-.365.89-.605a16 16 0 0 1 7.792-2.037c2.827-.006 5.48.72 7.782 2 .429.239.643.358.888.6.271.27.542.733.644 1.102.093.332.092.646.09 1.273v.186c-.001.63-.002.944-.086 1.199a1.69 1.69 0 0 1-1.071 1.07c-.255.085-.57.085-1.198.087h-.23c-.415.002-.622.002-.793-.034a1.66 1.66 0 0 1-1.288-1.287c-.036-.172-.035-.379-.034-.793 0-.135 0-.203-.01-.27a.87.87 0 0 0-.423-.597 1.4 1.4 0 0 0-.224-.09"
    }, null, -1)
  ])))
}
export default { render: render }